export const getAuthToken = (): string => {
	return getPersistentState<string>("auth.token", "");
};

export const setAuthToken = (token: string) => {
	return setPersistentState<string>("auth.token", token);
};

export const getWorkerAuthToken = (): string => {
	return getPersistentState<string>("worker.auth.token", "");
};

export const setWorkerAuthToken = (token: string) => {
	return setPersistentState<string>("worker.auth.token", token);
};

export const getPersistentState = <T>(key: string, defaultValue: T): T => {
	const storedValue = localStorage.getItem(key);
	try {
		if (storedValue === null) return defaultValue;
		return JSON.parse(storedValue);
	} catch (_) {
		return defaultValue;
	}
};

export const setPersistentState = <T>(key: string, value: T) => {
	try {
		const v = JSON.stringify(value);
		localStorage.setItem(key, v);
	} catch (_) {
		localStorage.setItem(key, value as string);
	}
};
